export const CircleNumber = ({ className = "w-5 h-5" }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path
				stroke="none"
				d="M0 0h24v24H0z"
				fill="none"
			/>
			<path d="M14 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
			<path d="M8 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
			<path d="M3 12v.01" />
			<path d="M7.5 4.2v.01" />
			<path d="M7.5 19.8v.01" />
			<path d="M4.2 16.5v.01" />
			<path d="M4.2 7.5v.01" />
			<path d="M12 21a9 9 0 0 0 0 -18" />
		</svg>
	);
};
